import React from 'react';
import classNames from 'classnames';
import sidebarStyles from '../../stylesheets/maintenance/sidebar.module.scss';

const Sidebar = () => {
  return (
    <aside className={sidebarStyles.sidebar}>
      <div className={sidebarStyles.sidebarHeader}>
        <div>
          <h3 className={sidebarStyles.sidebarTitle}>Filters</h3>
          <p className={sidebarStyles.sidebarSubtitle}>
            Refine maintenance requests
          </p>
        </div>
        <button className={sidebarStyles.resetButton} type="button">
          Reset
        </button>
      </div>
      <div className={sidebarStyles.searchGroup}>
        <label
          className={sidebarStyles.searchLabel}
          htmlFor="maintenance-search"
        >
          Search
        </label>
        <input
          id="maintenance-search"
          className={sidebarStyles.searchInput}
          type="text"
          placeholder="Search requests"
          value=""
          disabled
          readOnly
        />
      </div>
      <div className={sidebarStyles.filterGroup}>
        <div className={sidebarStyles.filterTitle}>Status</div>
        <div className={sidebarStyles.filterChips}>
          <span
            className={classNames(
              sidebarStyles.filterChip,
              sidebarStyles.filterChipActive
            )}
          >
            New (1)
          </span>
          <span className={sidebarStyles.filterChip}>Open (0)</span>
          <span className={sidebarStyles.filterChip}>In Progress (0)</span>
        </div>
      </div>
      <div className={sidebarStyles.filterGroup}>
        <div className={sidebarStyles.filterTitle}>Priority</div>
        <div className={sidebarStyles.filterChips}>
          <span
            className={classNames(
              sidebarStyles.filterChip,
              sidebarStyles.filterChipActive
            )}
          >
            High (1)
          </span>
          <span className={sidebarStyles.filterChip}>Medium (0)</span>
          <span className={sidebarStyles.filterChip}>Low (0)</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
